import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frequencySelect", "weeklyFields", "monthlyFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const frequency = this.frequencySelectTarget.value

    this.weeklyFieldsTarget.classList.toggle("hidden", frequency !== "weekly")
    this.monthlyFieldsTarget.classList.toggle("hidden", frequency !== "monthly")
  }
}
